export default __webpack_public_path__ + "static/media/dropdownTrash.8d04819a.svg";